import type { ReactNode } from 'react';
import { useAuthStore } from '../../stores/auth';
import { userHoldsAnyGate } from '../../lib/gateHeld';
import { resolveProfile } from '../../lib/profileIdentity';

/** Web guard for a page whose API needs a gate: a login that holds none of the keys sees a plain sentence, not a 403 banner. */
/** `orProfile`: a profile the server lets in without the key (tube boxes: the full-admin P18). */
export function RequireAnyGateRoute({ keys, children, sentence, orProfile }: { keys: readonly string[]; children: ReactNode; sentence: string; orProfile?: string }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return null;
  if (userHoldsAnyGate(user, keys) || (orProfile && resolveProfile(user) === orProfile)) return <>{children}</>;
  return <section role="alert" className="mx-auto max-w-xl p-8"><h1 className="text-2xl font-semibold">No access</h1><p className="mt-2">{sentence}</p><a href="/">Go to your home</a></section>;
}
